export const TABS = ['REGISTRATION', 'ACCREDITATION', 'TRAVEL', 'ACCOMMODATION'];

export const GUEST_FORM_IDS = {
  REGISTRATION:  '6a3c1896e68c83c53951b455',
  ACCREDITATION: '6a3c18fbe68c83c53951b45c',
  TRAVEL:        '6a3c18fce68c83c53951b460',
  ACCOMMODATION: '6a3c18fce68c83c53951b464',
};

/** Count panel/fieldset sections in a Form.io schema (for loading skeleton). */
export function countFormPanels(components) {
  let n = 0;
  const walk = (list) => {
    if (!Array.isArray(list)) return;
    list.forEach((c) => {
      if (!c) return;
      if (c.type === 'panel' || c.type === 'fieldset') n += 1;
      if (c.components) walk(c.components);
      if (c.columns) c.columns.forEach((col) => walk(col?.components));
    });
  };
  walk(components);
  return n > 0 ? n : 2;
}
